<template>
  <panel :heading="label">
    <div>How do you like the new design?</div>
    <div
      v-if="!$store.getters['session/hasRated']"
      class="emojis"
    >
      <span class="helper" />
      <template v-for="(name, index) in ['emoji_1', 'emoji_2', 'emoji_3', 'emoji_4']">
        <img
          v-if="!(name != selectedName && selectedName.length > 0)"
          :key="name"
          :src="emojiSource(name)"
          :class="{selected: selectedName == name}"
          @click="rateBeta(name, index + 1)"
        >
      </template>
    </div>
    <div
      v-else
      class="thanks"
    >
      Thanks for rating!
    </div>
  </panel>
</template>
<script>
import Panel from '@components/singletons/panel';

export default {
  components: { Panel },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedName: '',
    };
  },
  methods: {
    emojiSource(name) {
      return require(`../../assets/images/emojis/${name}.png`);
    },
    rateBeta(name, score) {
      this.selectedName = name;
      this.$analytics.events.ratedBeta(score);
      this.$store.commit('session/toggleHasRated');
    },
  },
};
</script>

<style lang='scss' scoped>
  img {
    cursor: pointer;
    height: 100%;
    margin-right: rem-calc(16);
    width: auto;
    max-height: rem-calc(32);
    transition: .25s;
    vertical-align: middle;

    &:hover {
      max-height: rem-calc(48);
    }

    &.selected {
      max-height: rem-calc(48);
    }
  }

  .emojis {
    height: rem-calc(48);
    margin-top: rem-calc(12);
    text-align: center;

    .helper {
      display: inline-block;
      height: 100%;
      vertical-align: middle;
    }
  }

  .thanks {
    box-sizing: border-box;
    margin-top: rem-calc(12);
    height: rem-calc(48);
    padding: rem-calc(16);
    text-align: center;
  }
</style>
